<template>
    <v-card >
        <v-card-text>
            <v-form
                ref="form">

                 <v-select
                    hide-details 
                    label="Activity Type"
                    v-model="form.activity_type_id"
                    :items="activityTypes"
                    clearable
                >
                </v-select>
                <v-select
                    hide-details 
                    label="Touch Point"
                    v-model="form.activity_touch_point_id"
                    :items="touchPoints"
                    clearable
                >
                </v-select>
                <v-text-field
                    :dense="false"
                    label="Activity Number" 
                    hide-details 
                    v-model="form.activity_code">
                </v-text-field>
               
                <user-search
                    :dense="false"
                    label="Created By" 
                    hide-details 
                    item-value="id" 
                    item-text="name"
                    v-model="form.user_id">
                </user-search>
                 <user-search
                    :dense="false"
                    label="Assigned To" 
                    hide-details 
                    item-value="id" 
                    item-text="name"
                    v-model="form.assignee_id">
                </user-search>
                <v-select   
                    label="State"
                    v-model="form.state"
                    hide-details="auto"
                    :items="states"
                    clearable>
                </v-select>
                <v-menu
                    ref="menu_date_from"
                    v-model="menu.date_from"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_from"
                            :rules="rules.date_from"
                            :label="$t('date_from')"
                            append-icon="mdi-calendar"
                            hide-details="auto"
                            readonly
                            v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_from" @input="menu.date_from = false" no-title scrollable></v-date-picker>
                </v-menu>
                
                <v-menu
                    ref="menu_date_to"
                    v-model="menu.date_to"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_to"
                            :rules="rules.date_to"
                            :label="$t('date_to')"
                            append-icon="mdi-calendar"
                            hide-details="auto"
                            readonly
                            v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker :min="form.date_from" v-model="form.date_to" @input="menu.date_to = false" no-title scrollable></v-date-picker>
                </v-menu>
                <customer-search
                    :dense="false"
                    label="Customer" 
                    hide-details 
                    item-value="id" 
                    item-text="display_name"
                    v-model="form.customer_id">
                </customer-search>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn
                text
                @click="submit" 
                :loading="loading" 
                :disabled="loading">
                {{ $t("search") }}
            </v-btn>
            <v-btn text @click="resetForm">
                {{ $t("reset") }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import { map } from 'lodash';
import { getCustomerActivityTouchPoints, getCustomerActivityTypes } from '../../services/sales/customerActivity';
import CustomerSearch from '../searchComponents/CustomerSearch';
import UserSearch from '../searchComponents/UserSearch';

export default {
    name: "CustomerActivitySearchMenu",
    components: {
        CustomerSearch,
        UserSearch
    },
    props: {
        loading: {
            required: false,
            type: Boolean
        },
        close: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            display: false,
            form: {
                state: null,
                user_id: null,
                assignee_id: null,
                customer_id: null,
                activity_type_id: null,
                activity_touch_point_id: null,
                activity_code :null
            },
            menu: {
                date_from: false,
                date_to: false
            },
            rules: {
                date_from: [

                ],
                date_to: [

                ]
            },
             states: [
                { text: "Open", value: "OPEN" },
                { text: "Closed", value: "CLOSED" },
                { text: "Overdue", value: "OVERDUE" },
            ],
            activityTypes: [],
            touchPoints:[]
        }
    },
    methods: {
        submit() {
            this.$emit("submit", this.form);
        },
        resetForm() {
            this.$refs.form.reset();
            this.form.user_id = null;
            this.form.customer_id = null;
        },
        async fetchActivityTypes() {
            let response = await getCustomerActivityTypes();

            this.activityTypes = map(response.data, (type) => {
                return {'text' : type.name, 'value' : type.id}
            });
        },
        async fetchTouchPoints() {
            let response = await getCustomerActivityTouchPoints();

            this.touchPoints = map(response.data, (touchPoint) => {
                return {'text': touchPoint.name, 'value': touchPoint.id}
            });
        }
    },
    created() {
        this.fetchActivityTypes();
        this.fetchTouchPoints();
    }
}
</script>